import React, { useEffect, useState, useRef, useCallback, memo } from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { selectScreenObjList, setScreenObjList, selectViewType, updateScreenObj, replaceScreenObj, selectCurrentChoiceId, setCurrentChoiceId }  from "./layoutSlice"
import utils from "../../utils"
import Player  from  "../player/Player"
import useBus, { useListener }  from "../../useBus"
import "./Layout.scss"
import { Counter } from '../counter/Counter';
import http from "../../http"
import { root } from 'postcss';

const Layout = () => {
  console.log("render layout ======>")
  const screnObjList = useSelector(selectScreenObjList);
  const currentChoiceId = useSelector(selectCurrentChoiceId);
 
  const dispatch = useDispatch();

  const bus = useBus();

  const [viewType] = useState("ws");
  const [streamType] = useState(0)


  const [styleList, setStyleList] = useState([]);


  const applyPlayH5DataRef = useRef(null)

  const playUIRefs = useRef([]);

  // 设置ref
  const setPlayUIRefs = useCallback((index) => (element) => {
    playUIRefs.current[index] = element;
  }, []);

  useListener('play', (data) => {
    console.log("play")
    applyPlayH5(data)
  })

  useListener('changeScreen', (num) => {
    console.log(`changeScreen: ${num}`)
    changeScreen(num)
  })

  useListener('closeAllPlayH5', () => {
    console.log("closeAllPlayH5")
    closeAllPlayH5()
  })

  useListener('closePlayH5', (index) => {
    console.log("closePlayH5")
    closePlayH5(index)
  })

  const eventLister  = (event, data)  => {
    console.log(screnObjList)
    switch(event) {
      case "click":
        dispatch(setCurrentChoiceId(data.id))
        break;
      case "stop":
        let index = screnObjList.findIndex(_ => _.id === data.id);
        if (index > -1 && screnObjList[index].hadUsed) {
            closePlayH5(index);
        }
        break;
      case "play":
        break;
      case "ptz":
        bus.emit("ptz", data)
        break;
      default:
          break;
    }
  }
  
  const closeAllPlayH5 = () => {//关闭所有视频
    const needCloseIndex = []
    for (let i = 0; i < screnObjList.length; i++) {
      if (screnObjList[i].hadUsed) {
        closePlayH5(i);
        needCloseIndex.push(i)
      }
    }

    if(needCloseIndex.length <= 0 ) {
      return Promise.resolve()
    }
    return Promise.all(needCloseIndex.map(item => {
      return  closePlayH5(item);
    })).then((results) => {
        // 所有 Promise 执行完毕后的操作
        console.log("所有 Promise 已经执行完毕", results);
    }).catch((error) => {
        console.error("某个 Promise 执行失败", error);
    });
  }


  const closePlayH5 = (index) => {//关闭指定播放
    console.log("closeplay h5")
    if(screnObjList[index].terminalId&&screnObjList[index].channel){
      playUIRefs.current&&playUIRefs.current[index]&&playUIRefs.current[index].closePlayH5();
      // let obj = {
      //   device: that.screnObjList[index].terminalId,
      //   channel: that.screnObjList[index].channel,
      // }
      let obj = {
        streamid: screnObjList[index].streamid
      }
      http.postData("/live/stop",obj).then(function(res){//暂不支持调用停止接口
        if(!res.code){
        }
      }).catch(function(err){
        console.error("catchcatchcatchcatch",err);
      });

      // 清除属性状态
      const data  = utils.deepCopy(screnObjList[index])
      data.hadUsed = false;//标志为未使用
      
      for (let key in data) {//初始化窗口
        if (data.hasOwnProperty(key)&&key!="id"&&key!="hadUsed"&&key!="isDevice"&&key!="realPlay") {
          delete data[key];
        }
      }

      dispatch(replaceScreenObj({index:index, data}))
    }
  }
  
  const setWH = () => { // 计算宽高
    console.log("setWHW")
    let widthbfn = 2,heightbfn = 2,total = screnObjList.length;
    if(screnObjList.length==6) total = 9;
    if(screnObjList.length==8) total = 16;
    if(1<Number(Math.sqrt(total)) && Number(Math.sqrt(total))<2){
      widthbfn = 2;
      heightbfn = 1;
    }else{
      widthbfn = Math.sqrt(total);
      heightbfn = Math.sqrt(total);
    }
    const data = []
    for (let i = 0; i < screnObjList.length; i++) {
      let temp = {
        width: "calc("+(100/widthbfn)+"% - 2px)",
        height: heightbfn>1?"calc("+(100/heightbfn)+"% - 2px)":"100%",
        float: "left",
        margin: 0,
        display: "block",
        padding: "1px",
        background: "white"
      };
      if(i==0&&screnObjList.length==6){
        temp.width = "calc("+(100/3*2)+"% - 4px)";
        temp.height = "calc("+(100/3*2)+"% - 5px)";
      }else if(i==0&&screnObjList.length==8){
        temp.width = "calc(75% - 6px)";
        temp.height = "calc(75% - 6px)";
      }

      setTimeout(() => {
        if((screnObjList[i].streamid)) {
          // this.$refs.child[i].resize()/
        }
      });

      data.push(temp)
    }
    setStyleList(data)
  }

  useEffect(()=> {
    setWH();
  }, [screnObjList.length])

  
  const applyPlayH5 =  (devData) => {//播放
    console.log("applyPlayH5")
    const playH5List = utils.deepCopy(screnObjList)
    let _i = playH5List.findIndex(_=>_.terminalId===devData.device&&_.channel===devData.id);
    if(_i>-1){
      return;
    }
    
    let needAddScreen = true;//需要添加窗口
    for (let n = 0; n < playH5List.length; n++) {
      if(!playH5List[n].hadUsed){//找到未使用的窗口然后用起来
        needAddScreen = false;
        playH5List[n].terminalId = devData.device;
        playH5List[n].name = devData.name;
        playH5List[n].channel = devData.id;
        playH5List[n].streamType = streamType;
        
        // 保存数据
        applyPlayH5DataRef.current = {
          ...devData, 
          index: n,
          action: "play"
        };

        dispatch(setScreenObjList(playH5List))
        return;
      }
    }


    if(playH5List.length==64){
      alert("当前预览数量已达到最大数！");
      return;
    }
    if(needAddScreen){//需要添加窗口
      let num = playH5List.length;
      changeScreen(num+1);

      // 保存数据
      applyPlayH5DataRef.current = {
        ...devData, 
        index: num,
        action: "add"
      };

      return

    }
  }

  useEffect(() => { // 开始播放
    if(applyPlayH5DataRef.current && applyPlayH5DataRef.current.action === "play") {
      specifyPlayVideoH5(applyPlayH5DataRef.current.index)
    }
  }, [screnObjList])

  useEffect(() => { // 修改播放属性
    if(applyPlayH5DataRef.current && applyPlayH5DataRef.current.action === "add") {
      const playH5List = utils.deepCopy(screnObjList)
      playH5List[applyPlayH5DataRef.current.index].terminalId = applyPlayH5DataRef.current.device;
      playH5List[applyPlayH5DataRef.current.index].name = applyPlayH5DataRef.current.name;
      playH5List[applyPlayH5DataRef.current.index].channel = applyPlayH5DataRef.current.id;
      playH5List[applyPlayH5DataRef.current.index].streamType = streamType;
      dispatch(setScreenObjList(playH5List))
      applyPlayH5DataRef.current = {...applyPlayH5DataRef.current, action: "play"}
    }
  }, [screnObjList.length])



  const specifyPlayVideoH5 = (index) => {//指定视频窗口播放-index-第几个窗口，从0开始
    console.log(`specifyPlayVideoH5: ${index}`)
    applyPlayH5DataRef.current = null 
    let params = {
      streamType: streamType,
      viewType : viewType
    }

    console.log("params", params)

    const substream = params.streamType ==  1 ? true : false;
    let obj = {
      device: screnObjList[index].terminalId,
      channel: screnObjList[index].channel,
      substream: substream,
    }
    http.postData("/live/start",obj).then(function(res){
      if(!res.code){
        let playUrl = null;
        if(params.viewType == 'rtc') {
          if(res.WebRTC) {
            playUrl = res.WebRTC.replace(/https|http/g, "webrtc");
          }
        } else {
          playUrl = res.WebSocket;
          if(res.WebSockets){
            playUrl = res.WebSockets;
          }
          // if(window.location.protocol==='https:'){
          //   playUrl = res.WebSockets;
          // }
        }

        // that.clickScreen(that.screnObjList[index]);
        dispatch(updateScreenObj({index, streamid: res.StreamID, hadUsed: true, playProtocol: res}))
        // that.$emit("updateParent",{
        //   screenId: that.screnObjList[index].id,
        //   oprateType: 1
        // });
        console.log(playUrl, substream);
        playUIRefs.current[index].specifyPlayVideoH5(playUrl, params.viewType);
      }
    }).catch(function(err){
      // that.$emit("updateParent",{
      //   screenId: that.screnObjList[index].id,
      //   oprateType: 2
      // });
    });
  }


  const changeScreen = async (len) => {
    const screnObjListCopy = utils.deepCopy(screnObjList)
    let num = 1;
    if(len<3){
      num = len;
    }else if(len<=4){
      num = 4;
    }else if(len<=6){
      num = 6;
    }else if(len<=8){
      num = 8;
    }else if(len<=9){
      num = 9;
    }else if(len<=16){
      num = 16;
    }else if(len<=25){
      num = 25;
    }else if(len<=36){
      num = 36;
    }else{
      num = 64;
    }
  
    console.log("我要分频",num);
    let start = screnObjListCopy.length;
    if(num>start){//增加
      for (let i = start; i < num; i++) {
        screnObjListCopy.push({id: utils.randomStr(8),hadUsed: false,isDevice:true,realPlay:true});
      }
    }else if(num<start){//减少
      let delN = start-num;//要减少的数量
      for (let i = 0; i < screnObjListCopy.length; i++) {
        if(delN>0){
          if(!screnObjListCopy[i].hadUsed){
            --delN;
            screnObjListCopy.splice(i,1);
            --i;
          }
        }else{
          break;
        }
      }
  
      if (delN > 0 ) {
        while(screnObjListCopy.length > num) {
          if(screnObjListCopy[screnObjListCopy.length-1].hadUsed){
         //  await this.$refs.h5play.closePlayH5(state.screnObjList.length-1);
           // await playUIRefs.current[screnObjList.length-1].closePlayH5()
          }
          --delN;
          screnObjListCopy.splice(screnObjListCopy.length-1,1);
        }
      }
      //重新排序，把使用的排前面
      screnObjListCopy.sort(function(a, b) {
        if(a.hadUsed===b.hadUsed){
          return 0;
        }else if(a.hadUsed&&!b.hadUsed){
          return -1;
        }else{
          return 1;
        }
      });
    }
    dispatch(setScreenObjList(screnObjListCopy))
  }

  
  useEffect(() => {
    console.log("useeffect")
    console.log(screnObjList)
  }, [screnObjList])
  

  return (
    <div className='left-block'>
      <div id="car-eye-player"  className="plays-box" >
        {screnObjList.map((data, idx) => {
            return <Player ref={setPlayUIRefs(idx)}  eventLister={eventLister} style={styleList[idx]} key={data.id} classname={{choice: currentChoiceId == data.id}}  params={data} />;
        })}
      </div>
    </div>
  );
}

export default memo(Layout)